import styled from "styled-components";

const HomeHeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px;

  .notification {
    cursor: pointer;
  }
`;

export { HomeHeaderWrapper };
